import * as Sentry from "@sentry/nextjs"
import Seo from "../components/SEO"
import { getPageContents } from "../components/contentful/pageProps"
import { ErrorUI } from "../components/ErrorUI"

const ErrorPage = () => (
    <>
        <Seo
            title="Error | Maaco"
            description="Something went wrong loading this page."
        />
        <ErrorUI heading="Error">
            Something went wrong loading this page. Please try again later.
        </ErrorUI>
    </>
)

export async function getStaticProps(props) {
    await Sentry.captureUnderscoreErrorException(props)
    return getPageContents(props)
}

export default ErrorPage
